
export const landingCarousel = [
    {
        id: 1,
        image: "3.jpg",
    },
    {
        id: 2,
        image: "1.jpg",
    },
    {
        id:3,
        image: "2.jpg"
    }
];

export const solutionCarousel = [
    {
        id: 1,
        image: "servicpic.svg",
        title: "Electrical Installations",
        subtitle: "You cannot afford to have installations done wrong. Do not put your personnel, equipment, and entire distribution network in the hands of amateurs. Work with our experts to implement your projects up to 330KV Substation installations. ",
        subtitle2:'We have comprehensive training on how to install state-of-the-art electrical equipment.'    ,
        link: ""
    }
]


export const Nojaproducts = [
    {
        id: 1,
        name: "OSM 38 Three Phase (33kV)",
        manufacturer: "Noja Power",
        image: "nojaproduct/osm_three.svg",
        desc: "The key interrupter architecture of the OSM Recloser can be deployed  in four different variants. Ganged three-phase for 3-wire distribution systems, Two phase for 2 Wire Single Phase applications, Single Phase for  Single Wire Earth Return (SWER) Applications, and un-ganged Three phase  (Single Triple) for 4-wire overhead distribution systems.",
        add : ["The World’s Only Arc Fault Vented Solid Dielectric Recloser" , "Designed for a maintenance free life" , "Supported by an international network of Technical Staff" , "Ganged ultra-fast magnetic actuators to provide additional operator safety" , "Hot Line Tag functionality and Mechanical trip interlock directly connected to the OSM tank’s operating mechanism" ," Unique and seamless NOJA Power Android and iOS App enhances linesmen comfort and safety" , "Internal double pole position indicator micro switches for added reliability" , "Triple shielded, water blocked and metal conduit protected control cable with military grade IP65  rated connectors" , "Grey powder coated tank to prevent drivers from being blinded by the sunlight reflecting on  the tank" ," Only 3 electronic modules in total that can be replaced within 5 minutes with a simple screwdriver" , "Remote and quick firmware upgrades to keep up with the industry changes over time"],
        link: "https://v1.api.seenergysolutions.org/api/brochure/noja/download"
    },
    {
        id: 2,
        name: "OSM 15 Three Phase (11kV)",
        manufacturer: "Noja Power",
        image: "nojaproduct/small.png",
        desc: "The key interrupter architecture of the OSM Recloser can be deployed  in four different variants. Ganged three-phase for 3-wire distribution systems, Two phase for 2 Wire Single Phase applications, Single Phase for  Single Wire Earth Return (SWER) Applications, and un-ganged Three phase  (Single Triple) for 4-wire overhead distribution systems.",
        add: ["Class Defining Current and Voltage Sensors, included on both load and source side of the devi as standa" , "Full Automation, Logic and Synchronising Feeder Capability as stand" , "Over 100 different protection features, from the simplest Overcurrent and Earth Fault Protecti through to Admittance, Fault Locator and Harmonic Protect" , "No Active Electronics in the Recloser Tank – Providing exceptional surge immunity and reliability"],
        link: "https://v1.api.seenergysolutions.org/api/brochure/noja/download"

    },
    {
        id: 5,
        name: "RC Controller",
        manufacturer: "Noja Power",
        image: "nojaproduct/rc_controller.svg",
        add: [
            "Full Directional Protection for Overcurrent, Earth Fault, Negative Phase Sequence and Sensitive "
            , "Earth Faults, with advanced gate technology for responding to low fault currents"
            , "ANSI, IEC255 and User Defined Protection curve for ultimate flexibility"
            , "Instantaneous high set elements and definite time protection"
            , "The worlds’ highest resolution SEF feature at 200mA minimum pickup*"
            , "Advanced Voltage, Current and Composite Protection such as Broken Conductor, Admittance and Harmonic Protection"
            , "Complete suite of Power Quality Monitoring and logging tools included as Standard."
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/noja/download"


    },
    {
        id: 6,
        name: "GMK-1000",
        manufacturer: "Noja Power",
        image: "nojaproduct/gmk_1000.svg",
        desc: "The Compact GMK 1000 Series offers a protection solution for underground cables using Solid Dielectric Insulation and Vacuum Interruption, with zero SF6 gas. A comprehensive suite of protection functionality is equipped as standard, delivered by the NOJA Power RC10, RC15 or RC20 control system built into the arrangement. Factory tested, the compact GMK provides simple commissioning ensuring correct operation between Primary and Secondary systems with minimal wiring on site.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/noja/download"

    },
    {
        id: 7,
        name: "GMK-2000",
        manufacturer: "Noja Power",
        image: "nojaproduct/gmk_2000.svg",
        desc: "The 2000 Series GMK is a modular switchgear platform, building on the core architecture of a NOJA Power OSM Recloser system with RC control for Ground Mount Applications. Custom options include Revenue Metering, Differential Protection, Interlocked Earth Switch or Power Quality Metering.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/noja/download"

    }
];


export const Lucyproducts = [
    {
        id: 1,
        name: "Up to 24 kV Side & Rear Cable Entry RMU",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/slide_rear_cable.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"
    },
    {
        id: 2,
        name: "Up to 24 KV Front Cable Entry RMU",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/front_cable.svg",
        desc: "Front cable termination, SF6 insulated RMU with 3 and 4 switching functions in a single stainless steel enclosure",
        add: [
            "12kV, 17.5kV and 24kV with up to 630A ratings"
            , "Non-extensible range with 3 and 4 switching functions in a single IP67 rated stainless steel tank"
            , "Any combination of load break switches and vacuum circuit breakers available"
            , "No on-site SF6 gas handling for installation"
            , "Internal arc protection of AF, AFL and AFLR"
            , "Intuitive single line mimic diagram"
            , "Horizontal cable terminations with DIN 400 Type C bushings"
            , "Front access Earth and Test facility"
            , "Integrated motorisation for remote control operation"
            , "Vacuum circuit breaker protection with TLF or relays"
            , "Suitable for Indoor (IP4X) and outdoor (IP54) applications"
            , "Integrated RTU for easy SCADA connection, with optional automatic transfer scheme (ATS)"
            , "Fully interlocked, anti-reflex mechanisms with padlocks"
            , "Maintenance free with 30 years life expectancy"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 3,
        name: "Up to 36 kV Front Cable Entry RMU",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/36_front_cable.svg",
        desc: "Front cable termination, SF6 insulated RMU with 3 and 4 switching functions in a single stainless steel enclosure",
        add: [
            "12kV, 17.5kV and 24kV with up to 630A ratings"
            , "Non-extensible range with 3 and 4 switching functions in a single IP67 rated stainless steel tank"
            , "Any combination of load break switches and vacuum circuit breakers available"
            , "No on-site SF6 gas handling for installation"
            , "Internal arc protection of AF, AFL and AFLR"
            , "Intuitive single line mimic diagram"
            , "Horizontal cable terminations with DIN 400 Type C bushings"
            , "Front access Earth and Test facility"
            , "Integrated motorisation for remote control operation"
            , "Vacuum circuit breaker protection with TLF or relays"
            , "Suitable for Indoor (IP4X) and outdoor (IP54) applications"
            , "Integrated RTU for easy SCADA connection, with optional automatic transfer scheme (ATS)"
            , "Fully interlocked, anti-reflex mechanisms with padlocks"
            , "Maintenance free with 30 years life expectancy"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 4,
        name: "17.5 kV Side & Rear Cable Entry Fuse Switch RMU",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/slide_rear_cable_fuse_switch.svg",
        desc: "Lateral and rear cable termination, SF6 gas insulated RMU, fully weather proof with IP54 for outdoor applications.",
        add: [
            "Up to 24kV and 630A ratings"
            , "Non extensible, extensible and modular range"
            , "Switching functions enclosed in SF6 gas insulated stainless steel tank sealed for life"
            , "Intuitive single line mimic diagram for simple and safe operation"
            , "Integrated cable Earth and Test facility"
            , "Choice of TLF (time limit fuses) or self / auxiliary powered relay protection"
            , "Anti reflex mechanism to prevent load break switch opening under fault conditions"
            ," Fully interlocked operation with padlocking facility for maximum operator protection"
            , "Freestanding and transformer mounted units"
            , "Actuators (motorised) for ring switches and circuit breakers"
            , "IP54 for outdoor installation without requiring a kiosk"
            , "Seamless integration with SCADA network  for remote operation and control"
            ," Maintenance free with 30 years life expectancy"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 5,
        name: "Up to 15.5 kV Fuse Switch RMU",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/15_fuse_switch.svg",
        desc: "Lateral and rear cable termination, oil insulated ring main unit designed for harsh and corrosive environmental conditions.",
        add: [
            "Up to 15.5kV and 630A ratings"
        ," Non extensible, extensible and modular range"
        ," Intuitive single line mimic diagram for simple and safe operation"
        , "Integrated Earth and Test facility for easy and safe cable test without removing cable connections"
        , "Anti reflex mechanism to prevent ring switch opening under fault conditions"
        , "Fully interlocked operation with padlocking facility for maximum operator protection"
        , "Freestanding and transformer mounted units"
        , "Actuators (motorised) for ring switches"
        ," Fuse switch fitted with shunt trips for remote tripping"
        ," Seamless integration with SCADA network for remote operation and control"
        , "IP54 for outdoor installation without requiring a kiosk"
        ," Maintenance free with 30 years life expectancy"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 6,
        name: "Up to 36kV Air Break Switch Disconnectors",
         manufacturer: "Lucy Electric",
        image: "lucyproduct/36_air_break.svg",
        desc: "The Rapier AX air break switch disconnector range is compact and robust, providing a reliable, lightweight and flexible solution for network isolation and reinstatement. Incorporating a modular design switch that can be configured to suit a variety of applications, the range combines high performance and reliability and is particularly suited to rural environments",
        add: [
           " 12 / 15.5 / 24 / 36kV options"
        , "Lightweight, universal base design for all voltages"
        , "Horizontal or vertical mounting on standard        steelwork both pole top and underline"
        ," Fully type tested and compliant with IEC ENATS and other standards"
        ," Silicon insulators"
        ," Dependent Manual (DM) and Independent Manual Spring (IMS) assisted hookstick mechanism, and down pole handle variants"
        ," AX can be supplied with full remote control for automation (AX-A) or the automation can be retrofitted at a later date"
        ," Optional load break capabilities"
        ," Optional earth blades"
        ," Can be fitted with expulsion fuses (vertical mounting only)"
        , "Enhanced dielectric values"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 7,
        name: "Up to 145Kv Double Side Break Disconnectors",
         manufacturer: "Lucy Electric",
        image: "lucyproduct/double_slide_break.svg",
        desc: "The Rapier double side break disconnector range provides a powerful and cost effective solution for isolating circuits and equipment in substation applications. Based on open terminal air break technology, the range combines robustness and  alignment reliability",
        add: [
            "Ratings up to 145kV and 2500A"
            , "Robust design"
            , "High endurance and reliability"
            , "Suitable for horizontal and vertical installation"
            , "Fault withstand current up to 40kA / 3sec"
            , "Double side break"
            , "Optional integral earth blades either or both sides"
            , "Manual or motor operation"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 8,
        name: "Up to 36kV Dropout (expulsion) Fuses",
         manufacturer: "Lucy Electric",
        image: "lucyproduct/dropout_fuse.svg",
        desc: "The Lucy Electric range of HV isolating links provide a reliable and economic solution for the isolation of overhead distribution lines and transformers and a visual indication of operation and positive disconnection from supply. Available in 12kV and 36kV options, each single phase link unit can be attended from the ground with an insulated operating pole.",
        add: [
            "Voltage range: 12kV and 36kV"
            , "Current rating: 400A"
            , "Short time current: 16kA / 3sec at 12kV; 12.5kA / 3sec at 36kV"
            , "Integral connector terminals suitable for conductor sizes up to 19mm diameter"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 9,
        name: "12 kV and 36 kV Isolation Links",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/isolation_link.svg",
         desc: "The Lucy Electric range of HV isolating links provide a reliable and economic solution for the isolation of overhead distribution lines and transformers and a visual indication of operation and positive disconnection from supply. Available in 12kV and 36kV options, each single phase link unit can be attended from the ground with an insulated operating pole.",
         add: [
             "Voltage range: 12kV and 36kV"
             , "Current rating: 400A"
             , "Short time current: 16kA / 3sec at 12kV; 12.5kA / 3sec at 36kV"
             , "Integral connector terminals suitable for conductor sizes up to 19mm diameter"
         ],
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"
    },
    {
        id: 10,
        name: "Enclosed Load Break Switch",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/load_break_switch.svg",
        desc: "The Rapier GX pole-mounted, gas insulated, load break switch has been developed as a complementary alternative to Rapier AX air break switches. Available up to 38kV, the GX switch has been designed using SF6 puffer switching technology, delivering high performance and reliability. Whether operated as a simple, manually-independent switch or equipped with fully automated features, the GX switch is suitable for all sectionalising and network automation requirements.",
        add: [
            "Stainless steel tank sealed for life"
            , "Hookstick or motor operated"
            , "Suitable for single wood pole mounting (other arrangements available)"
            , "Independent spring operation ensuring consistent opening and closing times"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 11,
        name: "MSDB horizontal busbar 3 phase 400 V 315 A rated",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/horizontal_busbar.svg"
    
    },
    {
        id: 12,
        name: "Insulated 10-way MSDB 3 phase 400 V 315 A rated",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/insulated_10way.svg",
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id:13,
        name: "Multi-Service Distribution Boards 3 phase 400 V 630 A rated",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/multi_service_distribution.svg",
         desc: "Mild steel wall mounting distribution boards for 3 phase systems configurable with either a single incoming bank of triple pole J type slotted tag fuses or with an additional outgoing bank of triple pole J type fuses for mixed developments requiring a split supply greater than 100A. ",
         add: [
            , "Up to 45 outgoing 3 phase fuse ways"
            , "1 J and 2 J versions available in left or right hand layouts"
            , "Top or bottom entry"
            , "2 door design with segregated access to DNO fuses"
            , "Thumb screw operated fuse handles with 92mm BS88 J type fuses"
            , "BS7657 outgoing fused ways"
            , "Polyester powder coated steel enclosure"
            , "Suitable for 3C or 4C networks"
            ," Pre-drilled removable gland plates"
         ],
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 14,
        name: "Fused Distribution Cabinet 3 phase 400 V 1600 A rated",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/fused_distribution.svg",
        desc: "Transformer mounted BS88 J type fused distribution cabinets. The term AcuLok signifies the accurate and positive locking operation of fuse handles on to the fuse ways in a single movement. The fuse handle has deep skirt shrouding to protect the operator from any arc flash during fuse handle manipulation. ",
        add: [
            "Innovative, safe and operator friendly AcuLok technology"
            ," Up to 8 outgoing fuse ways with 630A rating"
            , "Deep skirt shrouding around fuse handle for protecting operators against arc flash"
            , "Independent load make – load break disconnector switches for all three phases"
            , "Insulated Rogowski coil tube per fuse handle"
            ," Multi-functional digital meter with communication options"
            ," Veam Power Lock standby generator sockets with earth for emergency supply"
            , "IP34D protection for indoor and outdoor installation"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 15,
        name: "Single phase cut outs 230 V up to 100 A rated",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/single_phase_cut.svg",
        desc: "Fused cut outs in either CNE or SNE formats conforming to BS7657:2010 for the supply of domestic or light commercial installations",
        add: [
            "Dual phase and neutral terminals accept up to 35mm² conductors"
            , "Three phase CNE / SNE combinations with cable chambers"
            , "22mm or 30mm fuse barrel size depending on amperage"
            , "Reversible mounting (phase on left or right hand side) for all variants"
            , "Special version for legacy installations with PILC cables"
            , "Fire resistant slope board for mounting in meter cupboards"
            , "Two brass M8 pinching screws per conductor"
            , "Interlocked shrouds and covers with sealable fuse handle"
            , "Silver plated phase terminal block"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"

    },
    {
        id: 16,
        name: "Three Phase Cut Outs 400V up to 100 A rated",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/horizontal_busbar.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 17,
        name: "Combined CT Metering Chamber and HDCO 3 phase 400 V ",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/combined_ct_metering.svg",
        desc: "Wall mounting fused service heads with integrated CT metering having ratings up to 630A for indoor applications. Accepts smart meters with standard ISO mountings.",
        add: [
            "Metering class 0.5 CTs for all variants"
        , "Pre-wired with loom for direct connection of meter"
        , "VT protection fuses and solid neutral link"
        , "Segregated compartment design giving access firstly to meter check terminals then service connections"
        , "Transparent internal shrouds over terminations provides IPXXB protection with compartment door open"
        , "Suitable for 3C CNE or 4C SNE installations"
        , "Robust thermoplastic enclosure construction mounted on pre-drilled backboard"
        , "Sealable covers"
        , "Choice of shear off mechanical or lug incoming terminations"
        , "Choice of leader clamp, mechanical shear off or lug outgoing terminations"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 18,
        name: "Heavy Duty 3 phase 400 V up to 630A rated",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/heavy_duty.svg",
        desc: "Wall mounting fused service heads with ratings up to 630A for indoor applications. Can be fitted with integral CT metering  chamber which accepts latest generation smart meters.",
        add: [
            "200A, 400A and 630A versions"
            , "Thumb screw operated fuse handles with 83mm BS88 J type fuses for 200A"
            , "Thumb screw operated fuse handles with 92mm BS88 J type fuses for 400A and 630A versions"
            , "Transparent internal shrouds over terminations provides IPXXB protection with handles in place"
            , "Soft PVC shrouds for protection of incoming stalks with fuse handles removed"
            , "Suitable for 3C CNE or 4C SNE installations"
            , "Versions with no external earth connection"
            , "Robust thermoplastic enclosure construction"
            , "Sealable covers and cable troughs with interlocked covers"
            , "Choice of shear off mechanical or lug incoming terminations"
            , "Choice of leader clamp, mechanical shear off or lug outgoing terminations"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 19,
        name: "Fuse Handles",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/fuse_handles.svg",
         desc:" Fused 400A rated cut outs for pole mounting.",
         add: [
            "Accepts up to 300mm² aluminium conductors"
            , "High grade engineering thermoplastic for excellent UV resistance"
            , "IP43 rating"
            , "Thumb screw operated fuse handle with brass clamps"
            , "Fixing via single coach screw"
            , "Closed cell foam cable grommets"
         ],
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 20,
        name: "Sub-Mains Distribution Boards",
         manufacturer: "Lucy Electric",
        image: "lucyproduct/sub_main_distribution.svg",
        desc: "200A rated distribution boxes for pole or wall mounting.",
        add: [
            "Up to 9 service ways from a three phase supply"
            , "CNE and SNE versions"
            , "Accepts up to 95mm² incoming ABC type conductors"
            , "High grade engineering thermoplastic for excellent UV resistance"
            , "IP43 rating"
            , "Two M8 pinching screws per conductor"
            , "Grease filled terminal blocks"
            , "Hinged door with restraint"
            , "Foam self-sealing cable entry gasket"
            , "Optional metal frame for mounting to concrete poles"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 21,
        name: "Gemini 3 Modular",
        manufacturer: "Lucy Electric",
        image: "lucyproduct/gemini_3_modular.svg",
        desc: "The Gemini 3 is a highly flexible and modula general-purpose Remote Terminal Unit (RTU) designed to remotely monitor and control medium / high voltage switchgear ",
        add: [
             "Fault detection (Earth and Phase)"
            , "LED status indicators"
            , "Real time clock (SCADA synchronised)"
            , "Dual isolated Ethernet and RS232 ports"
            , "Supervisory selection and indication"
            , "USB and HMI ports"
            , "Event memory – 6500 events in non-volatile memory"
            , "Optional flash SD memory card (factory fitted)"
        ],
        link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 22,
        name: "Gemini 3 Mini",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/gemini_3_mini.svg",
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 23,
        name: "Analogue Measurement Module",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/analogue_measurement.svg",
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    },
    {
        id: 24,
        name: "Package Substation",
         manufacturer: "Lucy Electric",
         image: "lucyproduct/package_substation.svg",
         link: "https://v1.api.seenergysolutions.org/api/brochure/lucy-electric/download"


    }
];

export const Replproducts = [
    {
        id: 1,
        name: "RHLT (Heat Shrink Low Voltage Cable Termination)",
        manufacturer: "REPL",
        image: "replproduct/rhlt.svg",
        desc: "For sealing and protection of indoor and outdoor low voltage 3 or 4 core cables with/without armouring",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 2,
        name: "RHT-X (Heat Shrink Medium Voltage Polymeric Cable Termination up to 42kV)",
        manufacturer: "REPL",
        image: "replproduct/rht_x.svg",
        desc: "For terminating polymeric insulated cables up to 42kV For terminating paper insulated cables up to 36kV Red anti-tracking tubes for excellent weathering protection Stress Control tubing for field control at screen cut Kits can be supplied for single and three core cable designs with/without armouring Suitable for mechanical or compression cable lugs Fully tested to CENELEC HD 629 / IEC 60502-4",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"
    },
    {
        id: 4,
        name: "RHTS (Heat Shrink Zinc Oxide Medium Voltage Cable Termination up to 24kV)",
        manufacturer: "REPL",
        image: "replproduct/rhts.svg",
        desc: "For terminating polymeric insulated cables up to 24kV Single tube design with red anti-tracking tubes for excellent weathering protection with an internal zinc oxide (ZnO) coating providing stress control around screen cut Kits can be supplied for single and three core cable designs with/without armouring Suitable for mechanical or compression cable lugs Fully tested to CENELEC HD 629",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 5,
        name: "RCST (Cold Shrink Medium Voltage Cable Termination up to 36kV)",
        manufacturer: "REPL",
        image: "replproduct/rcst.svg",
        desc: "For terminating polymeric insulated cables up to 36kV One piece silicon rubber body with moulded sheds and integrated stress cone Requires no heat or special tools for installation Kits can be supplied for single and three core cable designs with/without armouring Suitable for mechanical or compression cable lugs",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 6,
        name: "RHSB / RHRB (Heat Shrink Insulating cable bushing boot kits)",
        manufacturer: "REPL",
        image: "replproduct/rhsb.svg",
        desc: "Heat Shrink Insulating Boots can be used over medium voltage terminations to insulate bushings in cable boxes up to 36kV, particularly where the normal clearance between phase to phase and phase to earth is less than the required value. These boots provide protection against flashover in the event of any surge impulse, high humidity or rodent menace contact.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 7,
        name: "RCFB (Flexible Insulating cable bushing boot kits)",
        manufacturer: "REPL",
        image: "replproduct/rcfb.svg",
        desc: "The RCFB flexible insulating boot is a cold applied system to provide increased insulation for medium voltage cable terminations. They are used in switchgear and transformer cable boxes where the air clearances are not sufficient to prevent electrical flashover due to high humidity or rodents. The boots are manufactured from a highly insulating and anti-track material with excellent weathering properties for a durable long life installation.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 8,
        name: "RSEK (Solderless Earth Kit for metallic screens)",
        manufacturer: "REPL",
        image: "replproduct/rsek.svg",
        desc: "Sets of constant force springs and tinned copper braid to provide an earth connection from copper tape screened and armoured medium voltage cables. Kits can be used with all types of MV termination kits on single and three core cables.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 9,
        name: "RBG (Bolted Cable Gland)",
        manufacturer: "REPL",
        image: "replproduct/rbg.svg",
        desc: "The RBG range of glands are designed for use in conjunction with medium voltage terminations in cable boxes with entry hole flange stud spacing’s to BS2562. They provide a moisture seal and earth take off point and connection for the armours wires.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 10,
        name: "RUSK (Unscreened cable termination adapter for GIS)",
        manufacturer: "REPL",
        image: "replproduct/rusk.svg",
        desc: "The REPL Unscreened Separable Connector system is a right angled adapter designed to fit over standard MV Cable Terminations when used with equipment bushings to Type C according to EN 50180 and EN 50181. The RUSC can be easily disconnected for testing and then reconnected with standard tooling under dead break conditions",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
   
    {
        id: 11,
        name: "RINS/RISB (Pole Mounted Bracket & Stand-Off Insulator Kit)",
        manufacturer: "REPL",
        image: "replproduct/rins_risb.svg",
        desc: "The RINS and ISB are used to mount outdoor cable terminations onto poles or other suitable structures for connection onto overhead lines. RINS consist of a fibreglass core covered by a weatherproof silicone sleeve with alternative length sheds and mild steel caps at both ends with threaded mounting bars. They are used in conjunction with the RISB mounting bracket",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 12,
        name: "RPAE/RPAS (Outer Cone Screened Plug-in termination 12-24kV Interface A)",
        manufacturer: "REPL",
        image: "replproduct/rpae_rpas.svg",
        desc : "Straight and Elbow connector for terminating polymeric insulated cables onto equipment such as transformers etc. which has standard bushing profile Type A according to the standards EN50180 & EN50181.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 13,
        name: "RCL (Pre-assembled Medium Voltage Cable Loops",
        manufacturer: "REPL",
        image: "replproduct/rcl.svg",
        desc: "The RCL pre-assembled cable loops are short lengths of medium voltage cables with a range of pre-installed termination options on both endswhich allow customers to provide permanent or temporary connections",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 14,
        name: "RICP (Inner Cone Plug-in termination 12-36kV) ",
        manufacturer: "REPL",
        image: "replproduct/rhlt_heat.jpg",
        desc: "Cable termination plugs for connecting medium voltage cables to equipment with inner cone bushings according to EN50180 & EN50181",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 15,
        name: "RHLJ (Low Voltage Heat Shrink Cable Joints up to 3.3kV)",
        manufacturer: "REPL",
        image: "replproduct/rhlj.svg",
        desc: "RHLJ range of joints use REPL heat shrink tubes for insulation and outer protection. Versions are available for flexible unarmoured and armoured cables in standard voltage ranges of 0.6/1kv and 1.9/3.3kV. The kits normally do not include connectors. A version for jointing paper cables to polymeric insulated cables is also available.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 16,
        name: "RHCE-P (Enclosures for pressurised telecom cable in-line joints)",
        manufacturer: "REPL",
        image: "replproduct/rhce_p.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 17,
        name: "RHCE-NP (Enclosures for non-pressurised telecom cable in-line joints)",
        manufacturer: "REPL",
        image: "replproduct/rhce_np.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 18,
        name: "RITTU / RITTA (Thin Wall, heat shrinkable tubing",
        manufacturer: "REPL",
        image: "replproduct/rittu_ritta.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    
    {
        id: 19,
        name: " RIMTU / RIMTA (Medium Wall, heat shrinkable tubing)",
        manufacturer: "REPL",
        image: "replproduct/rimtu_rimta.svg",
        desc: "Heat Shrinkable Medium Wall Tubes to provide environmental protection to the cable cores of plastic and paper insulated cable terminations, and insulation over the connector area in cable joints rated up to 1kV. The insulating tubes are made from thermally stabilized, crosslinked, weather resistant polymeric material.The tubes can be supplied internally coated with hot meltadhesive (RIMTA).",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 20,
        name: "RIHTU / RIHTA (Heavy Wall, heat shrinkable tubing)",
        manufacturer: "REPL",
        image: "replproduct/rihtu_rihta.svg",
        desc: "Heat Shrinkable Heavy Wall Tubes (RIHT) are used for environmental sealing of plastic and paper insulated cable joints rated up to 36kV.These tubes are made from thermally stabilized, cross linked, UV and weather resistant polymeric material and have a nominal shrink ratio of 3:1 and an unlimited shelf life when stored at normal warehouse temperatures. The tubes can be supplied internally coated with hot melt adhesive (RIHTA).",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 21,
        name: " RIBT / RIBT-T (Busbar Insulation heat shrinkable tubing",
        manufacturer: "REPL",
        image: "replproduct/ribt_ribt-t.svg",
        desc: "Heat Shrinkable Busbar Insulating Tubing are used to insulate copper and aluminium busbars, preventing flashovers and accidentally induced discharge.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 22,
        name: "RTBM (Busbar Insulation heat shrinkable tape)",
        manufacturer: "REPL",
        image: "replproduct/rtbm.svg",
        desc: "Busbar Insulating Tape (RBTM) is a dual layer tape combining a heat shrinkable outer tape with excellent insulating and weathering properties with an inner hot melt adhesive, to provide moisture sealing. It is used to provide insulation enhancement and protection for copper or aluminium busbar sections where tube products cannot easily be applied. A single layer of RBTR applied at ⅔ overlap will provide AC withstand up to 17.5kV. Double layers will increase withstand level up to 36kV.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },

    {
        id: 23,
        name: "RWRS/RTSF (Wraparound heat shrinkable repair sleeves)",
        manufacturer: "REPL",
        image: "replproduct/rwrs_rtsf.svg",
        desc: "RWRS Heat Shrinkable Wrap-Around Sleeves are mainly used for repairing outer/inner sheath of cables. The Wrap-Around Sleeves are made from thermally stabilised, cross linked, weather resistant, polymeric material and is halogen free. The Sleeves are coated internally with hot melt adhesive. RTSF Reinforced Heat Shrink Splice Closure System is designed to provide excellent split resistance, environmental and mechanical protection for cable joints. The RTSF sleeves are made from a composite laminate material consisting of reinforcing glass fibres, polyethylene layers, an aluminium layer for moisture vapour transmission and hot melt adhesive on the inner surface. The outer surface of the sleeves have thermos-chromatic paint",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 24,
        name: "EC / CEC (Heat Shrink Cable End Caps)",
        manufacturer: "REPL",
        image: "replproduct/ec_cec.svg",
        desc: "EC Heat Shrinkable End Caps are used to provide a moisture tight seal on all types of cables. The caps are lined with a hot melt adhesive to provide a moisture seal. The end cap is made from thermally stabilised, cross linked polymer and are suitable for use in temperatures between -300C and +700C, and with internal pressures up to 0.05MPa. Other versions are available with conductive material (CEC series) or fitted with valves (ECV series) for pressurised cable applications",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    },
    {
        id: 25,
        name: "RHCE-NP (Enclosures for non-pressurised telecom cable in-line joints)",
        manufacturer: "REPL",
        image: "replproduct/rhce_np_joint.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    {
        id: 26,
        name: " EB (Heat Shrink Low Voltage Cable Breakouts)",
        manufacturer: "REPL",
        image: "replproduct/eb_heat.svg",
        desc: "Heat Shrinkable Cable Breakouts provide an environmental seal to the crutch of plastic and paper insulated cables, rated up to 1.1kV. The Breakout is made from thermally stabilised, cross linked, polymeric material. The Breakouts are internally coated with hot melt adhesive.",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"

    },
    
    {
        id: 27,
        name: " RIMTU / RIMTA (Medium Wall, heat shrinkable tubing)",
        manufacturer: "REPL",
        image: "replproduct/rimtu_rimta.svg",
        link: "https://v1.api.seenergysolutions.org/api/brochure/repl/download"


    }
    
    
];

export const Moreproducts = [
    {
        id: 1,
        name: "Distribution Transformer between values of 25KVA  - 2500KVA",
        manufacturer: "Noja Power",
        image: "moreproduct/1.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"
        // desc: "The key interrupter architecture of the OSM Recloser can be deployed  in four different variants. Ganged three-phase for 3-wire distribution systems, Two phase for 2 Wire Single Phase applications, Single Phase for  Single Wire Earth Return (SWER) Applications, and un-ganged Three phase  (Single Triple) for 4-wire overhead distribution systems.",
        // add : ["The World’s Only Arc Fault Vented Solid Dielectric Recloser" , "Designed for a maintenance free life" , "Supported by an international network of Technical Staff" , "Ganged ultra-fast magnetic actuators to provide additional operator safety" , "Hot Line Tag functionality and Mechanical trip interlock directly connected to the OSM tank’s operating mechanism" ," Unique and seamless NOJA Power Android and iOS App enhances linesmen comfort and safety" , "Internal double pole position indicator micro switches for added reliability" , "Triple shielded, water blocked and metal conduit protected control cable with military grade IP65  rated connectors" , "Grey powder coated tank to prevent drivers from being blinded by the sunlight reflecting on  the tank" ," Only 3 electronic modules in total that can be replaced within 5 minutes with a simple screwdriver" , "Remote and quick firmware upgrades to keep up with the industry changes over time"]

    },
    {
        id: 2,
        name: "Power Transformer with a power capacity of 2500KVA - 100MVA at 11kV, 33kV, 132kV",
        manufacturer: "Noja Power",
        image: "moreproduct/2.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

        // desc: "The key interrupter architecture of the OSM Recloser can be deployed  in four different variants. Ganged three-phase for 3-wire distribution systems, Two phase for 2 Wire Single Phase applications, Single Phase for  Single Wire Earth Return (SWER) Applications, and un-ganged Three phase  (Single Triple) for 4-wire overhead distribution systems.",
        // add: ["Class Defining Current and Voltage Sensors, included on both load and source side of the devi as standa" , "Full Automation, Logic and Synchronising Feeder Capability as stand" , "Over 100 different protection features, from the simplest Overcurrent and Earth Fault Protecti through to Admittance, Fault Locator and Harmonic Protect" , "No Active Electronics in the Recloser Tank – Providing exceptional surge immunity and reliability"]

    },
    {
        id: 3,
        name: "AAC",
        manufacturer: "Noja Power",
        image: "moreproduct/3.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

    },
    {
        id: 4,
        name: "ACSR",
        manufacturer: "Noja Power",
        image: "moreproduct/4.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"


    },
    {
        id: 5,
        name: "ACCC",
        manufacturer: "Noja Power",
        image: "moreproduct/5.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

    },
    {
        id: 6,
        name: "Solar Cable",
        manufacturer: "Noja Power",
        image: "moreproduct/6.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

        // desc: "The Compact GMK 1000 Series offers a protection solution for underground cables using Solid Dielectric Insulation and Vacuum Interruption, with zero SF6 gas. A comprehensive suite of protection functionality is equipped as standard, delivered by the NOJA Power RC10, RC15 or RC20 control system built into the arrangement. Factory tested, the compact GMK provides simple commissioning ensuring correct operation between Primary and Secondary systems with minimal wiring on site."

    },
    {
        id: 7,
        name: "Medium & High Voltage Cable for 11kV, 33kV, 132kV, 330kV",
        manufacturer: "Noja Power",
        image: "moreproduct/7.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

        // desc: "The 2000 Series GMK is a modular switchgear platform, building on the core architecture of a NOJA Power OSM Recloser system with RC control for Ground Mount Applications. Custom options include Revenue Metering, Differential Protection, Interlocked Earth Switch or Power Quality Metering."
    },
    {
        id: 8,
        name: "Low Voltage Cable 1000V",
        manufacturer: "Noja Power",
        image: "moreproduct/8.png",
        link:"https://v1.api.seenergysolutions.org/api/brochure/osm-guide/download"

        // desc: "The 2000 Series GMK is a modular switchgear platform, building on the core architecture of a NOJA Power OSM Recloser system with RC control for Ground Mount Applications. Custom options include Revenue Metering, Differential Protection, Interlocked Earth Switch or Power Quality Metering."
    }
];

export const ElearnVideo = [
    {
        id: 1,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cablecheck.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 2,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/instrument.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 3,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cabling.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 4,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cabling.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 5,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cablecheck.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 6,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/instrument.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 7,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/instrument.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 8,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cablecheck.svg",
        video: "video/YAYA_LITE.mp4"

    },
    {
        id: 9,
        name: "Battery Charger/Tripping Units",
        views: "200 Views",
        date: "1 month ago",
        image:"elearn/cabling.svg",
        video: "video/YAYA_LITE.mp4"

    }
]